import * as React from 'react';

const RightArrow = (props) => {
  const { isSolid, ...svgProps } = props;
  if (isSolid) {
    return (
      <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 16 16"
        fill={props.fill}
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        <path
          d="M1 8H15M15 8L8 1M15 8L8 15"
          stroke={props.fill}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  } else
    return (
      <svg
        width={props.width}
        height={props.height}
        {...svgProps}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.623 12.547a.494.494 0 0 1-.353-.147.503.503 0 0 1 0-.707L12.963 8 9.27 4.307a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l4.046 4.047a.503.503 0 0 1 0 .706L9.977 12.4c-.1.1-.227.147-.354.147Z"
          fill={props.fill}
        />
        <path
          d="M13.556 8.5H2.336a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h11.22c.273 0 .5.227.5.5s-.227.5-.5.5Z"
          fill={props.fill}
        />
      </svg>
    );
};

RightArrow.defaultProps = {
  width: 16,
  height: 16,
  fill: '#94A3B8',
  isSolid: false
};

export { RightArrow };
